import LanguageList from "./pages/ListPage.vue";
import LanguageDetail from "./pages/FormPage.vue";
import LanguageIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/language",
    component: LanguageIndex,
    redirect: "/language/list",
    name: "language",
    children: [
      {
        path: "list",
        component: LanguageList,
        name: "language.list",
      },
      {
        path: "create",
        component: LanguageDetail,
        name: "language.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: LanguageDetail,
        name: "language.edit",
        props: { create: false },
      },
    ],
  },
];
